module.exports = __webpack_public_path__ + "static/img/404.9509a7b5.png";